import { Component } from '@angular/core';

import { NavController } from 'ionic-angular';
import {AngularFire, FirebaseListObservable} from 'angularfire2';
import {ResidentSummaryPage} from '../../';


import {ThemeService, AuthService} from '../../../providers/index';
@Component({
  selector: 'page-resident-register',
  templateUrl: 'resident-register.html'
})

export class ResidentRegisterPage {

  residentList: FirebaseListObservable<any>;
  project: string;

  constructor(public navCtrl: NavController, public af: AngularFire, private _theme: ThemeService, private _auth: AuthService) {

    this.residentList = af.database.list('/residents');
    console.log('Theme: ' + this._theme.getNameOfTheme());

    this.project = this._theme.getNameOfTheme();

  }

  createResident(firstname, lastname, phonenumber, streetLine1, city, state, postcode, nim ) {
    this.residentList.push({
      fname: firstname,
      lname: lastname,
      phone: phonenumber,
      street1: streetLine1,
      city: city,
      state: state,
      postcode: postcode,
      residentialDevelopment: 'Pine Tree Lane',
      registeredDate: new Date(),
      nim: nim,
      approved: false
    }).then( newResident => {
      console.log('resident created: ' + firstname +', ' + lastname );
      this.navCtrl.push(ResidentSummaryPage); //TODO: go to Admin Resident summary
    }, error => {
      console.log('ERROR: resident not created: ' +  + firstname +', ' + lastname  );
      console.log(error);
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ResidentRegisterPage');
  }

  // Only go here if we need to
  ionViewCanEnter(): boolean {
    if(this._auth.authenticated){
      console.log('Authenticated so you can see this page: ');
      return true;
    } else {
      console.log('Not Authenticated so you cannot see this page: '); //TODO: Add reference to page
      return false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/resident/resident-register/resident-register.ts